import { BrandPlanScheduleContentStatus } from 'types'

export interface ContentsFilters {
  status?: BrandPlanScheduleContentStatus | BrandPlanScheduleContentStatus[]
}

export const scheduleKeys = {
  all: ['schedules'] as const,
  lists: () => [...scheduleKeys.all, 'list'] as const,
  list: (filters: string) => [...scheduleKeys.lists(), { filters }] as const,
  details: () => [...scheduleKeys.all, 'detail'] as const,
  detail: (id: number) => [...scheduleKeys.details(), id] as const,
  pending: (workspaceId: number) => [...scheduleKeys.all, workspaceId, 'pending'] as const,
  contents: (scheduleId: number, filters?: ContentsFilters, items?: number) =>
    filters !== undefined || items !== undefined
      ? ([...scheduleKeys.detail(scheduleId), 'contents', 'list', { filters, items }] as const)
      : ([...scheduleKeys.detail(scheduleId), 'contents', 'list'] as const),
  contentDetail: (scheduleId: number, contentId: number) =>
    [...scheduleKeys.detail(scheduleId), 'contents', 'detail', contentId] as const,
  referenceImage: (scheduleId: number, contentId: number) =>
    [...scheduleKeys.contentDetail(scheduleId, contentId), 'reference_image'] as const,
}
